import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Components
import NavBar from './components/NavBar/NavBar';
import Footer from './Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';

// Service Pages
import Home from './Home/Home';
import Contact from './Contact/Contact';
import AppSoftware from './components/Service/AppSoftware';
import ContentWriting from './components/Service/ContentWriting';
import InfluencerMarketing from './components/Service/InfulancerMarketing';
import OnlineBranding from './components/Service/OnlineBranding';
import PerformanceMarketing from './components/Service/PerfomanceMarketing';
import ProductShoot from './components/Service/ProductShoot';
import Seo from './components/Service/Seo';
import SocialMediaMang from './components/Service/SocialMediaMang';
import VideoEditing from './components/Service/VideoEditing';
import ServiceHomePage from './components/ServiceHomePage/ServiceHomePage';

// Lazy-loaded Components
const Project = lazy(() => import('./components/Project/Project'));
const About = lazy(() => import('./components/About/About'));
const Blog = lazy(() => import('./Blog/Blog'));
const ClintReview = lazy(() => import('./ClintReview/ClintReview'));
const WeWorkWith = lazy(() => import('./WeWorkWith/WeWorkWith'));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <NavBar />

      <main>
        <Routes>
          {/* Home Page */}
          <Route path="/" element={<Home />} />

          {/* Services */}
          <Route path="/app-software" element={<AppSoftware />} />
          <Route path="/content-writing" element={<ContentWriting />} />
          <Route path="/influencer-marketing" element={<InfluencerMarketing />} />
          <Route path="/online-branding" element={<OnlineBranding />} />
          <Route path="/performance-marketing" element={<PerformanceMarketing />} />
          <Route path="/product-photography" element={<ProductShoot />} />
          <Route path="/seo-services" element={<Seo />} />
          <Route path="/social-media-management" element={<SocialMediaMang />} />
          <Route path="/video-editing" element={<VideoEditing />} />
          <Route path="/servicehomepage" element={<ServiceHomePage />} />

          {/* Contact */}
          <Route path="/contact" element={<Contact />} />

          {/* Lazy-loaded Pages */}
          <Route
            path="/projects"
            element={
              <Suspense fallback={<div>Loading Projects...</div>}>
                <Project />
              </Suspense>
            }
          />
          <Route
            path="/about"
            element={
              <Suspense fallback={<div>Loading About...</div>}>
                <About />
              </Suspense>
            }
          />
          <Route
            path="/blog"
            element={
              <Suspense fallback={<div>Loading Blog...</div>}>
                <Blog />
              </Suspense>
            }
          />
          <Route
            path="/clintreview"
            element={
              <Suspense fallback={<div>Loading Reviews...</div>}>
                <ClintReview />
              </Suspense>
            }
          />
          <Route
            path="/weworkwith"
            element={
              <Suspense fallback={<div>Loading Companies...</div>}>
                <WeWorkWith />
              </Suspense>
            }
          />

          {/* 404 Page */}
          <Route
            path="*"
            element={
              <div style={{ padding: '50px', textAlign: 'center' }}>
                <h2>404 - Page Not Found</h2>
              </div>
            }
          />
        </Routes>
      </main>

      <Footer />
    </Router>
  );
}

export default App;